"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var context_meta_1 = require("@shared/types/context-meta");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var SERVICE_NAME = 'prActiveReport';
(function (angularModule) {
    /**
     * Properties that can be accessed at container.definition.contextMeta
     * @todo replace hardcoded vars throughout the code with reference to this object
     */
    angularModule.constant('pr.CONTEXT_META_KEYS', context_meta_1.CONTEXT_META_VARS);
    angularModule.factory(SERVICE_NAME, [
        '$q',
        '$http',
        'pr.API_ROUTES',
        '$filter',
        '$document',
        'pr.rsContainersWrapper',
        'rsEnvironment',
        'prEventService',
        '$routeParams',
        '$sanitize',
        'prSanitize',
        'prDynamicTranslationsHelperUtils',
        'prFieldsets',
        'pr.loggerService',
        'pr.customFilterUtils',
        function ($q, $http, API_ROUTES, $filter, $document, containers, env, eventService, $routeParams, $sanitize, sanitize, dynamicTranslationsHelperUtils, fieldsetsService, loggerService, customFilterUtils) {
            var logger = loggerService.getLoggerManager(SERVICE_NAME);
            var PAGE_BREAK_WIDGET_TYPE = 'pr.pagebreak';
            var ID_LENGTH = 5;
            var PAGE_BREAK_ID_PREFIX = 'PAGEBREAK_';
            var container = (env.get('container') || {});
            var activeReport = container.definition || container;
            if (container && container.definition) {
                var pages = getPages();
                // because ripsaw is so ridiculous, it uses a page to associate widget states.
                // To make flowing pages work, widgets are constantly moving pages.
                // So we always associate widget states with the first page,
                // regardless of the page the widget is actually on
                var firstPagePromise = !pages.length ? addPage() : $q.when(pages[0]);
                firstPagePromise.then(function (page) {
                    env.set('pageId', page._id);
                });
                // Initialization - add a page break at the beginning of each page
                // Note: page breaks are only for the UI, and will not be stored in container definition
                if (pages && pages.length) {
                    for (var i = 0; i < pages.length; i++) {
                        var page = pages[i];
                        if (!page.widgets) {
                            page.widgets = [];
                        }
                        if (i > 0) {
                            var firstWidget = page.widgets[0];
                            if (!(firstWidget && firstWidget._type === PAGE_BREAK_WIDGET_TYPE)) {
                                page.widgets.splice(0, 0, getNewPageBreak());
                            }
                        }
                    }
                }
            }
            // returns the active report
            function _getReport() {
                return activeReport;
            }
            function getReportId() {
                return activeReport._id;
            }
            /**
             * Gets the complete updated container.
             * This will include widget states of newly inserted widgets,
             * unlike the _getReport() function.
             * @return {object}
             */
            function getUpdatedContainer() {
                var url = [API_ROUTES.CONTAINERS, getReportId(), 'compound']
                    .join('/');
                return $http.get(url, {
                    params: {
                        inlineStates: true
                    }
                }).then(function (response) {
                    return response.data;
                });
            }
            function _patchReport(patch) {
                if ($routeParams.publicHash || $routeParams.preview) {
                    return;
                }
                patch._id = getReportId();
                // TODO: do validation on simple things that could be in the patch: Pages, description etc.
                return containers.patchContainer(patch._id, patch);
            }
            function getDescription() {
                var reportName = activeReport.description || '';
                return sanitize.stripHTML(reportName);
            }
            function setDescription(description) {
                var report = _getReport();
                var origDesc = report.description;
                report.description = description;
                var patchObject = {
                    description: description
                };
                var isDynamicTranslationEnabled = dynamicTranslationsHelperUtils.isDynamicTranslationsSupported();
                if (isDynamicTranslationEnabled && !report.translationId) {
                    report.translationId = 'definition';
                    report.translatableAttributes = ['description'];
                    patchObject.translationId = report.translationId;
                    patchObject.translatableAttributes = report.translatableAttributes;
                }
                return _patchReport(patchObject).catch(function (error) {
                    // they haven't changed it since we tried to
                    if (report.description === description) {
                        report.description = origDesc;
                    }
                    throw error;
                });
            }
            function updateDescription(description) {
                var report = _getReport();
                report.description = description || report.description;
            }
            //#region PAGES
            function saveAllPages() {
                var pages = getPages();
                return setPages(pages);
            }
            function getPages() {
                var report = _getReport();
                if (!report.pages) {
                    report.pages = [];
                    // we may need to patch the container
                }
                return report.pages;
            }
            function getPage(pageId) {
                return lodash_1.default.find(getPages(), { _id: pageId });
            }
            function getPageIndex(pageId) {
                return lodash_1.default.findIndex(getPages(), { _id: pageId });
            }
            function setPages(pages) {
                pages = pages || [];
                var report = _getReport();
                report.pages = pages;
                var cleanPages = [];
                for (var _i = 0, pages_1 = pages; _i < pages_1.length; _i++) {
                    var page = pages_1[_i];
                    var cleanPage = getCleanPage(page);
                    cleanPages.push(cleanPage);
                }
                return _patchReport({
                    pages: cleanPages
                });
            }
            function setPage(page) {
                var pages = getPages();
                var idx = lodash_1.default.findIndex(pages, { _id: page._id });
                if (idx < 0) {
                    return $q.reject('Please pass a valid page to save');
                }
                pages[idx] = page;
                return containers.savePage(getReportId(), getCleanPage(page));
            }
            /**
             * We add data that ripsaw will not persist, no reason sending this data to them
             */
            function getCleanPage(page) {
                if (!page.widgets) {
                    return page;
                }
                var cleanPage = lodash_1.default.cloneDeep(page);
                for (var i = cleanPage.widgets.length - 1; i >= 0; i--) {
                    var widget = cleanPage.widgets[i];
                    if (widget._type === PAGE_BREAK_WIDGET_TYPE) {
                        cleanPage.widgets.splice(i, 1);
                    }
                    else {
                        delete widget.chunks;
                        delete widget.finishedChunking;
                        delete widget.beginWaitingForLayoutStylesTime;
                        delete widget.state;
                        delete widget.isChunked;
                        delete widget.sectionId;
                    }
                }
                return cleanPage;
            }
            function addPage(page, index) {
                if (page === void 0) { page = {}; }
                if (!page) {
                    page = {};
                }
                lodash_1.default.defaults(page, {
                    description: '?',
                    icon: '?',
                    width: '12',
                    widgets: []
                });
                var pages = getPages();
                if (index) {
                    // if index is specified, insert new page at the index
                    pages.splice(index, 0, page);
                }
                else {
                    // else, add new page to the end
                    pages.push(page);
                }
                var cleanPage = getCleanPage(page);
                return containers.addPage(getReportId(), cleanPage).then(function (retPage) {
                    page._id = retPage._id;
                    if (index) {
                        return setPages(pages).then(function () { return page; });
                    }
                    return page;
                }).catch(function (error) {
                    // the add failed, so let's remove our page
                    var idx = pages.indexOf(page);
                    if (idx >= 0) {
                        pages.splice(idx, 1);
                    }
                    throw error;
                });
            }
            function removePage(page) {
                var pages = getPages();
                var idx = lodash_1.default.findIndex(pages, { _id: page._id });
                if (idx === -1) {
                    return $q.reject('page not found');
                }
                var deleted = pages.splice(idx, 1);
                return containers.deletePage(getReportId(), page._id).catch(function (error) {
                    pages.splice(idx, 0, deleted[0]);
                    throw error;
                });
            }
            //#endregion
            //#region WIDGETS
            function addWidget(pageId, widgetType, optLayout) {
                var widgetDef;
                var promise;
                if (widgetType === PAGE_BREAK_WIDGET_TYPE) {
                    widgetDef = getNewPageBreak();
                    promise = $q.when(widgetDef);
                }
                else {
                    widgetDef = {
                        _type: widgetType,
                        layout: lodash_1.default.defaults(optLayout || {}, getDefaultWidgetLayout())
                    };
                    promise = containers.addWidget(getReportId(), pageId, widgetDef);
                }
                return promise.then(function (result) {
                    widgetDef._id = result._id;
                    var page = getPage(pageId);
                    page.widgets = page.widgets || [];
                    page.widgets.push(widgetDef);
                    return widgetDef;
                });
            }
            function removeWidget(widget) {
                var page = getWidgetPage(widget);
                if (!page) {
                    return $q.reject();
                }
                var widgetIndex = lodash_1.default.findIndex(page.widgets, { _id: widget._id });
                // immediately remove it so we can be responsive in the UI
                page.widgets.splice(widgetIndex, 1);
                if (widget._type === PAGE_BREAK_WIDGET_TYPE) {
                    return $q.when();
                }
                return containers.deleteWidget(getReportId(), page._id, widget._id)
                    .catch(function (error) {
                    // it failed somehow, so put it back
                    page.widgets.splice(widgetIndex, 0, widget);
                    throw error;
                });
            }
            function copyWidget(widget, pivotWidget) {
                var srcPage = getWidgetPage(widget);
                var destPage = getWidgetPage(pivotWidget);
                if (!srcPage || !destPage) {
                    return $q.reject();
                }
                // fire off any saves just in case there are updates
                // to the copying widget that aren't on the server yet
                containers.flush();
                return containers.copyWidget(getReportId(), srcPage._id, destPage._id, widget._id)
                    .then(function (widgetDef) {
                    destPage.widgets.push(widgetDef);
                    return widgetDef;
                });
            }
            function getWidgetPage(widget) {
                if (!widget || !widget._id) {
                    return undefined;
                }
                var pages = getPages();
                return lodash_1.default.find(pages, function (page) {
                    return lodash_1.default.some(page.widgets, { _id: widget._id });
                });
            }
            function updateSelectedWidgetType(newType) {
                eventService.trigger('widgetSwitch', newType);
            }
            //#endregion
            //#region CONTEXT META
            /**
             * @todo This returns a reference, which allows outside
             * callers to directly modify the contextMeta.
             * But only this file should directly modify the contextMeta.
             * Investigate a way to prevent outside modifications.
             * See: https://qualtrics.atlassian.net/browse/REP-5497
             */
            function getContextMeta() {
                var report = _getReport();
                if (!report.contextMeta) {
                    report.contextMeta = {};
                    // we may need to patch the container
                }
                return report.contextMeta;
            }
            function setContextMeta(meta) {
                var report = _getReport();
                report.contextMeta = meta;
                return _patchReport({ contextMeta: meta });
            }
            function getMetadata(prop) {
                return prop ? getContextMeta()[prop] : getContextMeta();
            }
            /**
             * Updates the contextMeta of the report.
             * Triggers network request to save if there are any changes.
             * Clones the input to avoid keeping references to objects that callers can access.
             * @param prop - either an object with the context meta properties to update
             *               or a single string representing the property to update
             * @param value - if `prop` is a string, this is the new value for the property.
             *                Otherwise, it is undefined.
             */
            function setMetadata(prop, value) {
                var meta = getContextMeta();
                var clonedMeta = lodash_1.default.cloneDeep(meta);
                var isSameReference = false;
                if (lodash_1.default.isObject(prop)) {
                    isSameReference = meta === prop;
                    prop = lodash_1.default.cloneDeep(prop);
                    meta = mergeMetadata(meta, prop);
                }
                else {
                    isSameReference = lodash_1.default.isObject(value) && value === meta[prop];
                    value = lodash_1.default.cloneDeep(value);
                    var isDynamicTranslationEnabled = dynamicTranslationsHelperUtils.isDynamicTranslationsSupported();
                    if (isDynamicTranslationEnabled &&
                        prop === context_meta_1.CONTEXT_META_VARS.FILTERS &&
                        !customFilterUtils.isCustomFilterId(value)) {
                        meta[context_meta_1.CONTEXT_META_VARS.SAVED_FILTERS] = updateSavedFilters(value);
                    }
                    if (isDynamicTranslationEnabled && prop === context_meta_1.CONTEXT_META_VARS.CUSTOM_FILTERS) {
                        meta[context_meta_1.CONTEXT_META_VARS.CUSTOM_FILTERS] =
                            dynamicTranslationsHelperUtils.addDynamicTranslationsAttributesForCustomFilters(value);
                    }
                    else {
                        meta[prop] = value;
                    }
                }
                if (!lodash_1.default.isEqual(meta, clonedMeta) || isSameReference) {
                    /**
                     * If isSameReference === true, the caller has potentially
                     * modified the contextMeta object stored in this file, which
                     * makes it impossible to know if any modifications were made.
                     * So we need to save the state to be safe.
                     */
                    if (isSameReference) {
                        var message = SERVICE_NAME + ".setMetadata: Outside callers should not directly modify contextMeta";
                        console.error(message);
                        logger.warn(message);
                    }
                    return setContextMeta(meta);
                }
                return $q.when();
            }
            /**
             * Triggering any PATCH request will update the lastModifiedDate on the container.
             * So trigger a dummy PATCH request that doesn't really do anything.
             */
            function updateLastModifiedDate() {
                var product = activeReport.product;
                return _patchReport({ product: product });
            }
            function updateSavedFilters(updatedFilters) {
                var currentFilters = getMetadata(context_meta_1.CONTEXT_META_VARS.SAVED_FILTERS) || {};
                var newFilters = dynamicTranslationsHelperUtils.addDynamicTranslationsAttributesForFilters(updatedFilters);
                lodash_1.default.forEach(newFilters, function (filter, key) {
                    if (!lodash_1.default.has(currentFilters, key)) {
                        currentFilters[key] = filter;
                    }
                });
                return currentFilters;
            }
            /*
                Does the same as setMetadata(), except it does not call
                _patchContainer(); this is because prs should be making calls
                to patch containers.
            */
            function updateMetadata(prop, value) {
                var meta = getContextMeta();
                var report = _getReport();
                if (lodash_1.default.isObject(prop)) {
                    meta = mergeMetadata(meta, prop);
                }
                else {
                    meta[prop] = value;
                }
                report.contextMeta = meta;
            }
            function mergeMetadata(meta, prop) {
                // Do not recursively merge filter properties - can cause invalid filters
                return lodash_1.default.mergeWith(meta, prop, function (metaVal, propVal, key) {
                    if (key === context_meta_1.CONTEXT_META_VARS.FILTERS) {
                        lodash_1.default.assign(metaVal, propVal);
                    }
                });
            }
            //#endregion
            //#region OTHER
            function updateDocumentTitle(optTitle) {
                var reportTitle = optTitle || getDescription();
                var titleSuffix = $filter('translate')('GlobalSiteMeta.TITLE_SUFFIX');
                $document.title = reportTitle + " | " + titleSuffix;
                // $document does not work for actually changing title
                document.title = $document.title;
            }
            function updateLanguageCode(languageCode, saveToContainer) {
                languageCode = $sanitize(languageCode);
                var report = _getReport();
                if (saveToContainer && (report.language !== languageCode)) {
                    _patchReport({ language: languageCode });
                }
                report.language = languageCode;
                // Fetch translated fieldsets and add to in-memory cache
                var getFieldsetPromises = lodash_1.default.map(report.contextMeta[context_meta_1.CONTEXT_META_VARS.SURVEY_ID], function (sourceId) {
                    return fieldsetsService.getFieldsetBySourceId(sourceId, languageCode);
                });
                return $q.all(getFieldsetPromises);
            }
            function getLanguageCode() {
                var report = _getReport();
                return report.language;
            }
            function getPageIdOfWidget(widget) {
                if (!widget) {
                    return env.get('pageId');
                }
                if (widget.sectionId) {
                    return widget.sectionId;
                }
                var widgetId = widget._id;
                if (!widgetId) {
                    return env.get('pageId');
                }
                var page = getWidgetPage({ _id: widgetId });
                return (page && page._id) || env.get('pageId');
            }
            function getNewPageBreak() {
                return {
                    _type: PAGE_BREAK_WIDGET_TYPE,
                    _id: generatePageBreakId(),
                    layout: getDefaultWidgetLayout()
                };
            }
            /**
             * generate a new ID for page break
             */
            function generatePageBreakId() {
                var ret = '';
                var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                for (var i = 0; i < ID_LENGTH; i += 1) {
                    ret += possible.charAt(Math.floor(Math.random() * possible.length));
                }
                return PAGE_BREAK_ID_PREFIX + ret;
            }
            function getDefaultWidgetLayout() {
                return {
                    row: 0,
                    col: 0,
                    rowSpan: 6,
                    colSpan: 12
                };
            }
            //#endregion
            return {
                getUpdatedContainer: getUpdatedContainer,
                updateMetadata: updateMetadata,
                updateDocumentTitle: updateDocumentTitle,
                getReportId: getReportId,
                getDescription: getDescription,
                setDescription: setDescription,
                updateDescription: updateDescription,
                saveAllPages: saveAllPages,
                getPage: getPage,
                getPages: getPages,
                setPages: setPages,
                setPage: setPage,
                addPage: addPage,
                removePage: removePage,
                addWidget: addWidget,
                removeWidget: removeWidget,
                copyWidget: copyWidget,
                updateSelectedWidgetType: updateSelectedWidgetType,
                getMetadata: getMetadata,
                setMetadata: setMetadata,
                updateLastModifiedDate: updateLastModifiedDate,
                updateLanguageCode: updateLanguageCode,
                getLanguageCode: getLanguageCode,
                getPageIdOfWidget: getPageIdOfWidget,
                getWidgetPage: getWidgetPage,
                getPageIndex: getPageIndex
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
